<script>
import TwCard from '@/components/generic/tw-card.vue'
import TwContainer from '@/components/generic/tw-container.vue'
import TwInput from '@/components/generic/forms/tw-input.vue'
import TwPassword from '@/components/generic/forms/tw-password.vue'
import TwButton from '@/components/generic/tw-button.vue'
import TwValidationErrors from '@/components/generic/tw-validation-errors.vue'
import ImportOrganizationForUser from '@/components/imports/import-organization-for-user.vue'

export default {
  name: 'ImportingIndexPage',
  components: { ImportOrganizationForUser, TwValidationErrors, TwButton, TwPassword, TwInput, TwContainer, TwCard },
  data() {
    return {
      ValidationErrorMessage: null,
      CredentialEmail: null,
      CredentialPassword: null,
      UserOld: null,
      LoadingFetchingOldUser: false
    }
  },
  mounted() {
    this.CredentialEmail = 'studenthelpdesk@awmcharis.com'
    this.CredentialPassword = 'password'
  },
  methods: {
    async fetchOldUser() {
      try {
        this.ValidationErrorMessage = null
        this.LoadingFetchingOldUser = true
        const { data } = await axios.post('/api/v1/import/old-user', {
          email: this.CredentialEmail,
          password: this.CredentialPassword
        })
        this.UserOld = data
        this.LoadingFetchingOldUser = false
      } catch (e) {
        console.error(e)
        this.LoadingFetchingOldUser = false
        if (e.response) this.ValidationErrorMessage = e.response.data
        throw e
      }
    }
  }
}
</script>

<template>
  <tw-container>
    <!-- <h1>Data Importer</h1> -->
    <div class="grid sm:grid-cols-6">
      <import-organization-for-user v-if="UserOld" class="sm:col-span-4 sm:col-start-2 mt-10" :user-old="UserOld" />
      <tw-card v-else class="sm:col-span-2 sm:col-start-3 mt-10 bg-white">
        <h5 class="mb-6">Import your data from GroupRev</h5>
        <tw-input v-model="CredentialEmail" label="Username"/>
        <tw-password v-model="CredentialPassword" label="Password" class="mt-4 mb-6"/>
        <div class="flex justify-center">
          <tw-button :loading="LoadingFetchingOldUser" @click="fetchOldUser" size="padded">
            Get Organization
          </tw-button>
        </div>
        <tw-validation-errors :validation-result-error="ValidationErrorMessage" />
      </tw-card>
    </div>
  </tw-container>
</template>

<style scoped>

</style>
